<template>
  <div class="promptMessage-container">
    <img :src="iCons" alt="" />
   <div class="contentBox">
    <div class="content1">{{content1}}</div>
    <div :class="[type==='4'?'content2 dange':'content2']">{{content2 }}</div>
    <div class="content1">{{ content3 }}</div>

   </div>
  </div>
</template>

<script>
  import {formatDate} from "@/utils/Date"
import dangeIcon from '@/assets1/后台/dange.png'
import reviewIcon from '@/assets1/后台/review.png'
import successIcon from '@/assets1/后台/successInfo.png'
import delistingIcon from '@/assets1/后台/delisting.png'
export default {
    created(){
        console.log(this.type,'aaaaa')
    },
    data(){
        return{
            dangeIcon,reviewIcon,successIcon,delistingIcon
        }
    },
    props:{
        type:[Number, String],
        date:String
    },
    methods:{
        formatDate
    },
    computed:{
        Colors(){
          if(this.type==='4'){
            return 'rgba(233, 36, 36, 0.12)'
          }else if(this.type==='2'){
            return 'rgba(255, 208, 0, 0.12)'
          }else if(this.type==='6'){
                 return 'rgba(13, 83, 255, 0.12)'
          }else if(this.type==='5'){
      
             return 'rgba(248, 248, 248, 1)'
          }
          return 'rgba(248, 248, 248, 1)' // 添加默认返回值
        },
        iCons(){
            if(this.type==='4'){
                return this.dangeIcon
            }else if(this.type==='2'){
                return this.reviewIcon
            }else if(this.type==='6'){
                return this.successIcon
            }else if(this.type==='5'){
                return this.delistingIcon
            }
            return this.reviewIcon // 添加默认返回值
        },
        content1(){
            if(this.type==='4'){
                return '您的需求已'
            }else if(this.type==='2'){
                return '待审核：您的需求'
            }else if(this.type==='5'){
                return '已完成：您的需求'
            }else if(this.type==='6'){
                return '已下架：您的需求'
            }
            return '' // 添加默认返回值
        },
        content2(){
            if(this.type==='4'){
                return '被驳回'
            }else if(this.type==='2'){
                return '已提交'
            }else if(this.type==='5'){
                return '已完成'
            }else if(this.type==='6'){
                return '已下架'
            } 
            return '' // 添加默认返回值
        },
        content3(){
            if(this.type==='4'){
                return '。原因:请深入理解用户在核心产品路径'
            }else if(this.type==='2'){
                return '，待平台方审核后即可发布。'
            }else if(this.type==='5'){
                return `，完成日期${formatDate(this.date)}`
            }else if(this.type==='6'){
                return '，可重新编辑发布。'
            } 
            return '' // 添加默认返回值
        }
    }
};
</script>

<style scoped>
.promptMessage-container {
  width: 100%;
  padding: 14px 16px;
  background-color:v-bind(Colors);
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.contentBox{
    display: flex;
    font-family: Regular;
    font-size: 14px;
    margin-left: 8px;
}
.dange{
    color: red !important;
}
</style>
